// extracted by mini-css-extract-plugin
export default {"MainModal":"MainModal_MainModal__yv54c","drawer":"MainModal_drawer__Uj3yf"};